import React from "react";
import {
  Datagrid,
  DateField,
  List,
  TextField,
  TextInput,
  Filter,
  ReferenceField,
  SimpleShowLayout,
  BooleanInput,
  NumberInput,
  NumberField,
  BooleanField,
  required,
} from "react-admin";
import ShowView from "../../components/ShowView";
import CreateView from "../../components/CreateView";
import Emoji from "../../components/Emoji";
import EditView from "../../components/EditView";

const SpecialistCardFilter = (props) => (
    <Filter {...props}>
      <TextInput label="شناسه" source="objectId"/>
      <TextInput label="شناسه متخصص" source="specialistUserId"/>
      <NumberInput label="مبلغ" source="price"/>
      <TextInput label="sku" source="sku"/>
      <TextInput label="عنوان" source="title"/>
      <BooleanInput label="فعال" source="active"/>
      <TextInput label="توضیحات" source="description"/>
    </Filter>
);

export const SpecialistCardList = (props) => (
    <List {...props} filters={<SpecialistCardFilter/>}>
      <Datagrid rowClick={"show"}>
        <TextField sortable={false} source="objectId"/>
        <ReferenceField link="show" label="کاربر متخصص" source="specialistUserId" reference="user">
          <TextField source="name"/>
        </ReferenceField>
        <NumberField source="price"/>
        <TextField source="sku"/>
        <TextField source="title"/>
        <BooleanField source="active"/>
        <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
        <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
      </Datagrid>
    </List>
);

export const SpecialistCardShow = (props) => (
    <ShowView {...props}>
      <SimpleShowLayout>
        <TextField source="objectId"/>
        <ReferenceField link="show" label="کاربر متخصص" source="specialistUserId" reference="user">
          <TextField source="name"/>
        </ReferenceField>
        <NumberField source="price"/>
        <TextField source="sku"/>
        <TextField source="title"/>
        <BooleanField source="active"/>
        <TextField source="description"/>
        <TextField source="waitingMessage" label="پیام انتظار"/>
        <NumberField source="specialistPercentage" label="درصد مبلغ پزشک"/>
        <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
        <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
      </SimpleShowLayout>
    </ShowView>
);

export const SpecialistCardCreate = (props) => (
    <CreateView {...props}>
      <TextInput source="specialistUserId" validate={required()}/>
      <NumberInput source="price" validate={required()}/>
      <TextInput source="sku" validate={required()}/>
      <TextInput source="title"/>
      <BooleanInput source="active" defaultValue={false}/>
      <Emoji source="description" label="توضیحات" validate={required()}/>

      <NumberInput min={0} max={100} source="specialistPercentage" label="درصد مبلغ پزشک"/>
      <Emoji source="waitingMessage" label="پیام انتظار"/>
    </CreateView>
);

export const SpecialistCardEdit = (props) => (
    <EditView {...props}>
      <TextInput source="specialistUserId" validate={required()}/>
      <NumberInput source="price" validate={required()}/>
      <TextInput source="sku" validate={required()}/>
      <TextInput source="title"/>
      <Emoji source="description" label="توضیحات" validate={required()}/>

      <NumberInput min={0} max={100} source="specialistPercentage" label="درصد مبلغ پزشک" validate={required()}/>
      <Emoji source="waitingMessage" label="پیام انتظار" />
      <BooleanInput source="active" defaultValue={false}/>
    </EditView>
);
